// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.vero-services {
  padding: 0;
  background-color: #f9f9f9;
  font-family: "Poppins", sans-serif;
}


.vero-services__hero {
  position: relative;
  min-height: 70vh;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  color: white;
  overflow: hidden;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-attachment: fixed; 
}

/* Overlay for better text readability */
.vero-services__hero-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, 
    rgba(0, 0, 0, 0.7) 0%, 
    rgba(0, 0, 0, 0.5) 50%, 
    rgba(0, 0, 0, 0.3) 100%);
  z-index: 1;
}

.vero-services__hero-content {
  position: relative;
  z-index: 2;
  max-width: 900px;
  padding: 40px 20px;
  animation: fadeInUp 1s ease-out;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.vero-services__hero-title {
  font-family: "Montserrat", sans-serif;
  font-size: clamp(1.2rem, 4vw, 2.4rem);
  margin-bottom: 20px;
  font-weight: 800;
  line-height: 1.1;
  text-shadow: 2px 2px 12px rgba(0, 0, 0, 0.8);
  letter-spacing: -0.5px;
}

.vero-services__hero-subtitle {
  font-family: "Roboto", sans-serif;
  font-size: clamp(0.9rem, 2.0vw, 1.2rem);
  color: #f8f8f8;
  text-shadow: 1px 1px 8px rgba(0, 0, 0, 0.8);
  font-weight: 300;
  max-width: 750px;
  margin: 0 auto;
  line-height: 1.5;
}

/* Services Content */
.vero-services__title {
  text-align: center;
  font-size: clamp(1.5rem, 2.6vw, 2.0rem);
  color: #111;
  margin: 70px 0 30px;
  font-weight: 800;
  line-height: 1.1;
  font-family: "Montserrat", sans-serif;
  position: relative;
  padding-bottom: 20px;
}

.vero-services__title::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 120px;
  height: 5px;
 
  border-radius: 3px;
}

.vero-services__intro {
  text-align: center;
  font-size: clamp(1.2rem, 2vw, 1rem);
  color: #555;
  max-width: 900px;
  margin: 0 auto 70px;
  line-height: 1.8;
  font-weight: 500;
  font-family: "Montserrat", sans-serif;
  padding: 0 30px;
}

/* Services Grid */
.vero-services__grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 35px;
  padding: 30px;
  max-width: 1300px;
  margin: 0 auto 80px;
}

.vero-services__card {
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  height: 250px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  overflow: hidden;
  position: relative;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.vero-services__card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(180deg, 
    rgba(0, 0, 0, 0.2) 0%, 
    rgba(0, 0, 0, 0.7) 100%);
  transition: background 0.4s ease;
}

.vero-services__card:hover {
  transform: translateY(-15px) scale(1.03);
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.3);
}

.vero-services__card:hover::before {
  background: linear-gradient(180deg, 
    rgba(0, 0, 0, 0.3) 0%, 
    rgba(0, 0, 0, 0.85) 100%);
}

.vero-services__card-overlay {
  position: relative;
  z-index: 1;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  text-align: center;
  padding: 35px;
}

.vero-services__card-title {
  font-size: clamp(1.5rem, 2.5vw, 1.9rem);
  z-index: 2;
  margin: 0;
  line-height: 1.3;
  font-family: "Montserrat", sans-serif;
  font-weight: 700;
  text-shadow: 2px 2px 10px rgba(0, 0, 0, 0.9);
  
  opacity: 1;
  transform: translateY(0);
  transition: all 0.4s ease;
}

.vero-services__card:hover .vero-services__card-title {
 
  transform: scale(1.05); 
}
/* Modal Styles */
.vero-services__modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  backdrop-filter: blur(8px);
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.vero-services__modal {
  background: white;
  padding: 45px;
  border-radius: 20px;
  max-width: 700px;
  width: 90%;
  position: relative;
  box-shadow: 0 30px 80px rgba(0, 0, 0, 0.4);
  animation: modalSlideIn 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

@keyframes modalSlideIn {
  from {
    opacity: 0;
    transform: translateY(50px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.vero-services__modal-close {
  position: absolute;
  top: 20px;
  right: 20px;
  background: #f0f0f0;
  border: none;
  font-size: 1.8rem;
  cursor: pointer;
  color: #333;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.3s ease;
  font-weight: 300;
}

.vero-services__modal-close:hover {
  background: #e0e0e0;
  transform: rotate(90deg) scale(1.1);
}

.vero-services__modal-title {
  font-size: 2.2rem;
  margin-bottom: 25px;
  color: #111;
  font-weight: 800;
  line-height: 1.3;
  padding-right: 40px;
}

.vero-services__modal-content {
  font-size: 1.15rem;
  color: #555;
  line-height: 1.7;
  margin-bottom: 35px;
  font-weight: 400;
}

.vero-services__modal-link {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  margin-top: 25px;
  color: #2196f3;
  text-decoration: none;
  font-weight: 600;
  transition: all 0.3s ease;
  padding: 14px 28px;
  border: 2px solid #2196f3;
  border-radius: 8px;
  background: #f5f9ff;
  font-size: 1.1rem;
}

.vero-services__modal-link:hover {
  color: white;
  background: #2196f3;
  transform: translateY(-3px);
  box-shadow: 0 8px 25px rgba(33, 150, 243, 0.4);
}

/* Footer Styles */
.vero-services__footer {
  background: linear-gradient(135deg, #1a1a1a, #2c3e50);
  color: white;
  padding: 120px 20px 40px;
  margin-top: 100px;
  position: relative;
  overflow: hidden;
}

.vero-services__footer-wave {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 120px;
  background: linear-gradient(180deg, transparent, rgba(26, 26, 26, 0.8) 70%);
}

.vero-services__footer-content {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 40px;
  max-width: 1200px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
  background: rgba(255, 255, 255, 0.08);
  backdrop-filter: blur(12px);
  padding: 45px;
  border-radius: 20px;
  border: 1px solid rgba(255, 255, 255, 0.15);
  box-shadow: 0 15px 45px rgba(0, 0, 0, 0.25);
}

.vero-services__footer-section {
  text-align: left;
}

.vero-services__footer-heading {
  font-size: 1.7rem;
  margin-bottom: 22px;
  font-weight: 700;
  color: #fff;
  position: relative;
  padding-bottom: 12px;
}

.vero-services__footer-heading::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 55px;
  height: 3px;
  background: #ffeb3b;
}

.vero-services__footer-text {
  font-size: 1.05rem;
  line-height: 1.7;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.85);
}

.vero-services__footer-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.vero-services__footer-list-item {
  margin-bottom: 14px;
}

.vero-services__footer-link {
  color: rgba(255, 255, 255, 0.85);
  text-decoration: none;
  font-weight: 500;
  transition: all 0.3s ease;
  display: inline-block;
  padding: 6px 0;
  font-size: 1.05rem;
}

.vero-services__footer-link:hover {
  color: #ffeb3b;
  transform: translateX(10px);
}

.vero-services__footer-social {
  display: flex;
  gap: 20px;
  margin-top: 20px;
}

.vero-services__footer-social-link {
  color: white;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 46px;
  height: 46px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.12);
  text-decoration: none;
  font-size: 1.2rem;
}

.vero-services__footer-social-link:hover {
  color: #ffeb3b;
  transform: translateY(-6px) scale(1.1);
  background: rgba(255, 255, 255, 0.2);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.25);
}

.vero-services__footer-legal-links {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 28px;
  padding: 28px 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.15);
  border-bottom: 1px solid rgba(255, 255, 255, 0.15);
  margin: 35px auto 25px;
  max-width: 1200px;
}

.vero-services__legal-link {
  font-size: 0.95rem;
  color: rgba(255, 255, 255, 0.75);
  text-decoration: none;
  transition: all 0.3s ease;
  white-space: nowrap;
  padding: 7px 14px;
}

.vero-services__legal-link:hover {
  color: #ffeb3b;
  text-decoration: underline;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 5px;
}

.vero-services__contactus-footer {
  text-align: center;
  padding-top: 25px;
}

.vero-services__footer-copyright {
  font-size: 1rem;
  color: rgba(255, 255, 255, 0.7);
  margin: 0;
  padding: 0 20px;
}

/* Responsive Design */
@media (max-width: 1200px) {
  .vero-services__grid {
    max-width: 1000px;
    gap: 30px;
  }
  
  .vero-services__card {
    height: 230px;
  }
}

@media (max-width: 992px) {
  .vero-services__hero {
    min-height: 65vh;
    background-attachment: scroll; /* Remove parallax on mobile */
  }
  
  .vero-services__grid {
    grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
    gap: 28px;
  }
  
  .vero-services__card {
    height: 210px;
  }
  
  .vero-services__footer {
    padding: 100px 20px 35px;
    margin-top: 80px;
  }
  
  .vero-services__footer-content {
    padding: 35px;
  }
}

@media (max-width: 768px) {
  .vero-services__hero {
    min-height: 60vh;
  }
  
  .vero-services__hero-title {
    font-size: clamp(2rem, 4vw, 2.8rem);
    margin-bottom: 15px;
  }
  
  .vero-services__hero-subtitle {
    font-size: clamp(1.1rem, 2vw, 1.5rem);
  }
  
  .vero-services__title {
    margin: 50px 0 25px;
    font-size: clamp(1.8rem, 3.5vw, 2.5rem);
  }
  
  .vero-services__intro {
    margin-bottom: 50px;
    font-size: clamp(1rem, 1.8vw, 1.2rem);
    padding: 0 25px;
  }
  
  .vero-services__grid {
    grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
    gap: 25px;
    padding: 25px;
    margin-bottom: 70px;
  }
  
  .vero-services__card {
    height: 200px;
  }
  
  .vero-services__card-title {
    font-size: 1.4rem;
  }
  
  .vero-services__modal {
    padding: 35px;
    width: 92%;
  }
  
  .vero-services__modal-title {
    font-size: 1.8rem;
    margin-bottom: 20px;
  }
  
  .vero-services__modal-content {
    font-size: 1.05rem;
    margin-bottom: 30px;
  }
  
  .vero-services__modal-close {
    top: 18px;
    right: 18px;
    width: 38px;
    height: 38px;
    font-size: 1.7rem;
  }
  
  .vero-services__footer {
    padding: 80px 15px 30px;
    margin-top: 60px;
  }
  
  .vero-services__footer-content {
    grid-template-columns: 1fr;
    gap: 35px;
    padding: 30px;
  }
  
  .vero-services__footer-section {
    text-align: center;
  }
  
  .vero-services__footer-heading::after {
    left: 50%;
    transform: translateX(-50%);
  }
  
  .vero-services__footer-social {
    justify-content: center;
  }
  
  .vero-services__footer-legal-links {
    gap: 22px;
    padding: 22px 15px;
  }
  
  .vero-services__legal-link {
    font-size: 0.9rem;
  }
}

@media (max-width: 576px) {
  .vero-services__hero {
    min-height: 55vh;
  }
  
  .vero-services__hero-title {
    font-size: 2rem;
  }
  
  .vero-services__hero-subtitle {
    font-size: 1.1rem;
  }
  
  .vero-services__title {
    font-size: 2.1rem;
    margin: 40px 0 20px;
  }
  
  .vero-services__intro {
    font-size: 1.05rem;
    margin-bottom: 40px;
    padding: 0 20px;
  }
  
  .vero-services__grid {
    grid-template-columns: 1fr;
    max-width: 420px;
    gap: 22px;
  }
  
  .vero-services__card {
    height: 220px;
  }
  
  .vero-services__modal {
    padding: 28px 22px;
  }
  
  .vero-services__modal-title {
    font-size: 1.6rem;
  }
  
  .vero-services__modal-link {
    padding: 12px 24px;
    font-size: 1.05rem;
  }
  
  .vero-services__footer {
    padding: 70px 12px 25px;
    margin-top: 50px;
  }
  
  .vero-services__footer-legal-links {
    flex-direction: column;
    gap: 15px;
    align-items: center;
  }
  
  .vero-services__legal-link {
    white-space: normal;
    text-align: center;
    font-size: 0.85rem;
    padding: 8px 12px;
  }
  
  .vero-services__footer-copyright {
    font-size: 0.9rem;
  }
  
  .vero-services__footer-social-link {
    width: 42px;
    height: 42px;
    font-size: 1.1rem;
  }
}

@media (max-width: 400px) {
  .vero-services__hero {
    min-height: 50vh;
  }
  
  .vero-services__hero-title {
    font-size: 1.7rem;
  }
  
  .vero-services__hero-subtitle {
    font-size: 1rem;
  }
  
  .vero-services__grid {
    padding: 20px;
  }
  
  .vero-services__card {
    height: 190px;
  }
  
  .vero-services__card-title {
    font-size: 1.3rem;
  }
  
  .vero-services__footer-legal-links {
    gap: 12px;
  }
  
  .vero-services__legal-link {
    font-size: 0.8rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Services.css"],"names":[],"mappings":";AACA;EACE,UAAU;EACV,yBAAyB;EACzB,kCAAkC;AACpC;;;AAGA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA,wCAAwC;AACxC;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ;;;4BAG0B;EAC1B,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,qCAAqC;EACrC,qCAAqC;EACrC,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,4CAA4C;EAC5C,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;EACjC,uCAAuC;EACvC,cAAc;EACd,2CAA2C;EAC3C,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,uCAAuC;EACvC,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,qCAAqC;EACrC,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,YAAY;EACZ,WAAW;;EAEX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mCAAmC;EACnC,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,qCAAqC;EACrC,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,aAAa;EACb,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,2CAA2C;EAC3C,iDAAiD;AACnD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ;;4BAE0B;EAC1B,gCAAgC;AAClC;;AAEA;EACE,wCAAwC;EACxC,0CAA0C;AAC5C;;AAEA;EACE;;6BAE2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,uCAAuC;EACvC,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,qCAAqC;EACrC,gBAAgB;EAChB,4CAA4C;;EAE5C,UAAU;EACV,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA;;EAEE,sBAAsB;AACxB;AACA,iBAAiB;AACjB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,0CAA0C;EAC1C,yDAAyD;AAC3D;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA,kBAAkB;AAClB;EACE,qDAAqD;EACrD,YAAY;EACZ,wBAAwB;EACxB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,aAAa;EACb,2EAA2E;AAC7E;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,qCAAqC;EACrC,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,2CAA2C;EAC3C,2CAA2C;AAC7C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,qBAAqB;EACrB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,sCAAsC;EACtC,oCAAoC;EACpC,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,+CAA+C;EAC/C,kDAAkD;EAClD,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,SAAS;EACT,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE;IACE,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,6BAA6B,EAAE,8BAA8B;EAC/D;;EAEA;IACE,2DAA2D;IAC3D,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,wBAAwB;IACxB,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,mCAAmC;IACnC,mBAAmB;EACrB;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,mBAAmB;IACnB,uCAAuC;EACzC;;EAEA;IACE,mBAAmB;IACnB,qCAAqC;IACrC,eAAe;EACjB;;EAEA;IACE,2DAA2D;IAC3D,SAAS;IACT,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,UAAU;EACZ;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,SAAS;IACT,WAAW;IACX,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;IACT,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,SAAS;IACT,2BAA2B;EAC7B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,gBAAgB;IAChB,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":["\n.vero-services {\n  padding: 0;\n  background-color: #f9f9f9;\n  font-family: \"Poppins\", sans-serif;\n}\n\n\n.vero-services__hero {\n  position: relative;\n  min-height: 70vh;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  color: white;\n  overflow: hidden;\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  background-attachment: fixed; \n}\n\n/* Overlay for better text readability */\n.vero-services__hero-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(135deg, \n    rgba(0, 0, 0, 0.7) 0%, \n    rgba(0, 0, 0, 0.5) 50%, \n    rgba(0, 0, 0, 0.3) 100%);\n  z-index: 1;\n}\n\n.vero-services__hero-content {\n  position: relative;\n  z-index: 2;\n  max-width: 900px;\n  padding: 40px 20px;\n  animation: fadeInUp 1s ease-out;\n}\n\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(30px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.vero-services__hero-title {\n  font-family: \"Montserrat\", sans-serif;\n  font-size: clamp(1.2rem, 4vw, 2.4rem);\n  margin-bottom: 20px;\n  font-weight: 800;\n  line-height: 1.1;\n  text-shadow: 2px 2px 12px rgba(0, 0, 0, 0.8);\n  letter-spacing: -0.5px;\n}\n\n.vero-services__hero-subtitle {\n  font-family: \"Roboto\", sans-serif;\n  font-size: clamp(0.9rem, 2.0vw, 1.2rem);\n  color: #f8f8f8;\n  text-shadow: 1px 1px 8px rgba(0, 0, 0, 0.8);\n  font-weight: 300;\n  max-width: 750px;\n  margin: 0 auto;\n  line-height: 1.5;\n}\n\n/* Services Content */\n.vero-services__title {\n  text-align: center;\n  font-size: clamp(1.5rem, 2.6vw, 2.0rem);\n  color: #111;\n  margin: 70px 0 30px;\n  font-weight: 800;\n  line-height: 1.1;\n  font-family: \"Montserrat\", sans-serif;\n  position: relative;\n  padding-bottom: 20px;\n}\n\n.vero-services__title::after {\n  content: \"\";\n  position: absolute;\n  bottom: 0;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 120px;\n  height: 5px;\n \n  border-radius: 3px;\n}\n\n.vero-services__intro {\n  text-align: center;\n  font-size: clamp(1.2rem, 2vw, 1rem);\n  color: #555;\n  max-width: 900px;\n  margin: 0 auto 70px;\n  line-height: 1.8;\n  font-weight: 500;\n  font-family: \"Montserrat\", sans-serif;\n  padding: 0 30px;\n}\n\n/* Services Grid */\n.vero-services__grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 35px;\n  padding: 30px;\n  max-width: 1300px;\n  margin: 0 auto 80px;\n}\n\n.vero-services__card {\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  height: 250px;\n  border-radius: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  overflow: hidden;\n  position: relative;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);\n  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.vero-services__card::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(180deg, \n    rgba(0, 0, 0, 0.2) 0%, \n    rgba(0, 0, 0, 0.7) 100%);\n  transition: background 0.4s ease;\n}\n\n.vero-services__card:hover {\n  transform: translateY(-15px) scale(1.03);\n  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.3);\n}\n\n.vero-services__card:hover::before {\n  background: linear-gradient(180deg, \n    rgba(0, 0, 0, 0.3) 0%, \n    rgba(0, 0, 0, 0.85) 100%);\n}\n\n.vero-services__card-overlay {\n  position: relative;\n  z-index: 1;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  text-align: center;\n  padding: 35px;\n}\n\n.vero-services__card-title {\n  font-size: clamp(1.5rem, 2.5vw, 1.9rem);\n  z-index: 2;\n  margin: 0;\n  line-height: 1.3;\n  font-family: \"Montserrat\", sans-serif;\n  font-weight: 700;\n  text-shadow: 2px 2px 10px rgba(0, 0, 0, 0.9);\n  \n  opacity: 1;\n  transform: translateY(0);\n  transition: all 0.4s ease;\n}\n\n.vero-services__card:hover .vero-services__card-title {\n \n  transform: scale(1.05); \n}\n/* Modal Styles */\n.vero-services__modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.9);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  backdrop-filter: blur(8px);\n  animation: fadeIn 0.3s ease;\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n.vero-services__modal {\n  background: white;\n  padding: 45px;\n  border-radius: 20px;\n  max-width: 700px;\n  width: 90%;\n  position: relative;\n  box-shadow: 0 30px 80px rgba(0, 0, 0, 0.4);\n  animation: modalSlideIn 0.4s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n@keyframes modalSlideIn {\n  from {\n    opacity: 0;\n    transform: translateY(50px) scale(0.95);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n.vero-services__modal-close {\n  position: absolute;\n  top: 20px;\n  right: 20px;\n  background: #f0f0f0;\n  border: none;\n  font-size: 1.8rem;\n  cursor: pointer;\n  color: #333;\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  transition: all 0.3s ease;\n  font-weight: 300;\n}\n\n.vero-services__modal-close:hover {\n  background: #e0e0e0;\n  transform: rotate(90deg) scale(1.1);\n}\n\n.vero-services__modal-title {\n  font-size: 2.2rem;\n  margin-bottom: 25px;\n  color: #111;\n  font-weight: 800;\n  line-height: 1.3;\n  padding-right: 40px;\n}\n\n.vero-services__modal-content {\n  font-size: 1.15rem;\n  color: #555;\n  line-height: 1.7;\n  margin-bottom: 35px;\n  font-weight: 400;\n}\n\n.vero-services__modal-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  margin-top: 25px;\n  color: #2196f3;\n  text-decoration: none;\n  font-weight: 600;\n  transition: all 0.3s ease;\n  padding: 14px 28px;\n  border: 2px solid #2196f3;\n  border-radius: 8px;\n  background: #f5f9ff;\n  font-size: 1.1rem;\n}\n\n.vero-services__modal-link:hover {\n  color: white;\n  background: #2196f3;\n  transform: translateY(-3px);\n  box-shadow: 0 8px 25px rgba(33, 150, 243, 0.4);\n}\n\n/* Footer Styles */\n.vero-services__footer {\n  background: linear-gradient(135deg, #1a1a1a, #2c3e50);\n  color: white;\n  padding: 120px 20px 40px;\n  margin-top: 100px;\n  position: relative;\n  overflow: hidden;\n}\n\n.vero-services__footer-wave {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 120px;\n  background: linear-gradient(180deg, transparent, rgba(26, 26, 26, 0.8) 70%);\n}\n\n.vero-services__footer-content {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 40px;\n  max-width: 1200px;\n  margin: 0 auto;\n  position: relative;\n  z-index: 1;\n  background: rgba(255, 255, 255, 0.08);\n  backdrop-filter: blur(12px);\n  padding: 45px;\n  border-radius: 20px;\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  box-shadow: 0 15px 45px rgba(0, 0, 0, 0.25);\n}\n\n.vero-services__footer-section {\n  text-align: left;\n}\n\n.vero-services__footer-heading {\n  font-size: 1.7rem;\n  margin-bottom: 22px;\n  font-weight: 700;\n  color: #fff;\n  position: relative;\n  padding-bottom: 12px;\n}\n\n.vero-services__footer-heading::after {\n  content: \"\";\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 55px;\n  height: 3px;\n  background: #ffeb3b;\n}\n\n.vero-services__footer-text {\n  font-size: 1.05rem;\n  line-height: 1.7;\n  font-weight: 400;\n  color: rgba(255, 255, 255, 0.85);\n}\n\n.vero-services__footer-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.vero-services__footer-list-item {\n  margin-bottom: 14px;\n}\n\n.vero-services__footer-link {\n  color: rgba(255, 255, 255, 0.85);\n  text-decoration: none;\n  font-weight: 500;\n  transition: all 0.3s ease;\n  display: inline-block;\n  padding: 6px 0;\n  font-size: 1.05rem;\n}\n\n.vero-services__footer-link:hover {\n  color: #ffeb3b;\n  transform: translateX(10px);\n}\n\n.vero-services__footer-social {\n  display: flex;\n  gap: 20px;\n  margin-top: 20px;\n}\n\n.vero-services__footer-social-link {\n  color: white;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 46px;\n  height: 46px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.12);\n  text-decoration: none;\n  font-size: 1.2rem;\n}\n\n.vero-services__footer-social-link:hover {\n  color: #ffeb3b;\n  transform: translateY(-6px) scale(1.1);\n  background: rgba(255, 255, 255, 0.2);\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.25);\n}\n\n.vero-services__footer-legal-links {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 28px;\n  padding: 28px 20px;\n  border-top: 1px solid rgba(255, 255, 255, 0.15);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.15);\n  margin: 35px auto 25px;\n  max-width: 1200px;\n}\n\n.vero-services__legal-link {\n  font-size: 0.95rem;\n  color: rgba(255, 255, 255, 0.75);\n  text-decoration: none;\n  transition: all 0.3s ease;\n  white-space: nowrap;\n  padding: 7px 14px;\n}\n\n.vero-services__legal-link:hover {\n  color: #ffeb3b;\n  text-decoration: underline;\n  background: rgba(255, 255, 255, 0.05);\n  border-radius: 5px;\n}\n\n.vero-services__contactus-footer {\n  text-align: center;\n  padding-top: 25px;\n}\n\n.vero-services__footer-copyright {\n  font-size: 1rem;\n  color: rgba(255, 255, 255, 0.7);\n  margin: 0;\n  padding: 0 20px;\n}\n\n/* Responsive Design */\n@media (max-width: 1200px) {\n  .vero-services__grid {\n    max-width: 1000px;\n    gap: 30px;\n  }\n  \n  .vero-services__card {\n    height: 230px;\n  }\n}\n\n@media (max-width: 992px) {\n  .vero-services__hero {\n    min-height: 65vh;\n    background-attachment: scroll; /* Remove parallax on mobile */\n  }\n  \n  .vero-services__grid {\n    grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));\n    gap: 28px;\n  }\n  \n  .vero-services__card {\n    height: 210px;\n  }\n  \n  .vero-services__footer {\n    padding: 100px 20px 35px;\n    margin-top: 80px;\n  }\n  \n  .vero-services__footer-content {\n    padding: 35px;\n  }\n}\n\n@media (max-width: 768px) {\n  .vero-services__hero {\n    min-height: 60vh;\n  }\n  \n  .vero-services__hero-title {\n    font-size: clamp(2rem, 4vw, 2.8rem);\n    margin-bottom: 15px;\n  }\n  \n  .vero-services__hero-subtitle {\n    font-size: clamp(1.1rem, 2vw, 1.5rem);\n  }\n  \n  .vero-services__title {\n    margin: 50px 0 25px;\n    font-size: clamp(1.8rem, 3.5vw, 2.5rem);\n  }\n  \n  .vero-services__intro {\n    margin-bottom: 50px;\n    font-size: clamp(1rem, 1.8vw, 1.2rem);\n    padding: 0 25px;\n  }\n  \n  .vero-services__grid {\n    grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n    gap: 25px;\n    padding: 25px;\n    margin-bottom: 70px;\n  }\n  \n  .vero-services__card {\n    height: 200px;\n  }\n  \n  .vero-services__card-title {\n    font-size: 1.4rem;\n  }\n  \n  .vero-services__modal {\n    padding: 35px;\n    width: 92%;\n  }\n  \n  .vero-services__modal-title {\n    font-size: 1.8rem;\n    margin-bottom: 20px;\n  }\n  \n  .vero-services__modal-content {\n    font-size: 1.05rem;\n    margin-bottom: 30px;\n  }\n  \n  .vero-services__modal-close {\n    top: 18px;\n    right: 18px;\n    width: 38px;\n    height: 38px;\n    font-size: 1.7rem;\n  }\n  \n  .vero-services__footer {\n    padding: 80px 15px 30px;\n    margin-top: 60px;\n  }\n  \n  .vero-services__footer-content {\n    grid-template-columns: 1fr;\n    gap: 35px;\n    padding: 30px;\n  }\n  \n  .vero-services__footer-section {\n    text-align: center;\n  }\n  \n  .vero-services__footer-heading::after {\n    left: 50%;\n    transform: translateX(-50%);\n  }\n  \n  .vero-services__footer-social {\n    justify-content: center;\n  }\n  \n  .vero-services__footer-legal-links {\n    gap: 22px;\n    padding: 22px 15px;\n  }\n  \n  .vero-services__legal-link {\n    font-size: 0.9rem;\n  }\n}\n\n@media (max-width: 576px) {\n  .vero-services__hero {\n    min-height: 55vh;\n  }\n  \n  .vero-services__hero-title {\n    font-size: 2rem;\n  }\n  \n  .vero-services__hero-subtitle {\n    font-size: 1.1rem;\n  }\n  \n  .vero-services__title {\n    font-size: 2.1rem;\n    margin: 40px 0 20px;\n  }\n  \n  .vero-services__intro {\n    font-size: 1.05rem;\n    margin-bottom: 40px;\n    padding: 0 20px;\n  }\n  \n  .vero-services__grid {\n    grid-template-columns: 1fr;\n    max-width: 420px;\n    gap: 22px;\n  }\n  \n  .vero-services__card {\n    height: 220px;\n  }\n  \n  .vero-services__modal {\n    padding: 28px 22px;\n  }\n  \n  .vero-services__modal-title {\n    font-size: 1.6rem;\n  }\n  \n  .vero-services__modal-link {\n    padding: 12px 24px;\n    font-size: 1.05rem;\n  }\n  \n  .vero-services__footer {\n    padding: 70px 12px 25px;\n    margin-top: 50px;\n  }\n  \n  .vero-services__footer-legal-links {\n    flex-direction: column;\n    gap: 15px;\n    align-items: center;\n  }\n  \n  .vero-services__legal-link {\n    white-space: normal;\n    text-align: center;\n    font-size: 0.85rem;\n    padding: 8px 12px;\n  }\n  \n  .vero-services__footer-copyright {\n    font-size: 0.9rem;\n  }\n  \n  .vero-services__footer-social-link {\n    width: 42px;\n    height: 42px;\n    font-size: 1.1rem;\n  }\n}\n\n@media (max-width: 400px) {\n  .vero-services__hero {\n    min-height: 50vh;\n  }\n  \n  .vero-services__hero-title {\n    font-size: 1.7rem;\n  }\n  \n  .vero-services__hero-subtitle {\n    font-size: 1rem;\n  }\n  \n  .vero-services__grid {\n    padding: 20px;\n  }\n  \n  .vero-services__card {\n    height: 190px;\n  }\n  \n  .vero-services__card-title {\n    font-size: 1.3rem;\n  }\n  \n  .vero-services__footer-legal-links {\n    gap: 12px;\n  }\n  \n  .vero-services__legal-link {\n    font-size: 0.8rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
